import React from "react";
import { NavLink } from "react-router-dom";
import { Users, ListChecks } from "lucide-react";

const TABS = [
  { to: "/people", label: "People", icon: Users, end: true },
  { to: "/people/lists", label: "Lists", icon: ListChecks },
];

export function CrmTabs() {
  return (
    <div className="flex items-center gap-1 border-b border-slate-200 mb-5 overflow-x-auto tr-scroll [&>*]:shrink-0" data-testid="crm-tabs">
      {TABS.map((t) => (
        <NavLink key={t.to} to={t.to} end={t.end} data-testid={`crm-tab-${t.label.toLowerCase()}`}
          className={({ isActive }) => `flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium border-b-2 -mb-px transition-colors ${isActive ? "border-brand text-brand" : "border-transparent text-slate-500 hover:text-slate-700"}`}>
          <t.icon className="w-4 h-4" /> {t.label}
        </NavLink>
      ))}
    </div>
  );
}
